import { pickThemeColor } from '@/theme';
import styled from 'styled-components';

export const StyledCard = styled.div`
  border-bottom: 1px solid ${pickThemeColor('DIVIDER')};
`;

export const StyledContainer = styled.div`
  padding: 0 1rem 1.75rem 1rem;
`;

export const StyledPagination = styled.div`
  max-width: 53%;
`;
